<ul>
      @if (showFilter) {
      <li>
        <input
          class="k-textbox k-input k-rounded-md"
          (input)="onInput($event)" appAutoFocus
        />
      </li>
      } @for (item of currentData; track item; let i = $index) {
      <li
        #itemElement
        (click)="onSelectionChange(valueAccessor(item), itemElement)"
        [ngClass]="{ 'k-selected': isItemSelected(item) }"
      >
        <input
          type="checkbox"
          #notification
          kendoCheckBox
          [checked]="isItemSelected(item)"
        />
        <kendo-label
          class="k-checkbox-label"
          [for]="notification"
          [text]="textAccessor(item)"
        ></kendo-label>
      </li>
      }
    </ul>

<!-- <ul>
  <li *ngIf="showFilter">
    <input
      class="k-textbox k-input k-rounded-md"
      (input)="onInput($event)" appAutoFocus
    />
  </li>
  <li
    #itemElement
    *ngFor="let item of currentData; let i = index"
    (click)="onSelectionChange(valueAccessor(item), itemElement)"
    [ngClass]="{ 'k-selected': isItemSelected(item) }"
    [ngStyle]="{'display':'flex'}"
  >
    <input
      type="checkbox"
      #notification
      kendoCheckBox
      [checked]="isItemSelected(item)"
      [ngStyle]="{'margin-top':'3px'}"
    />
    <kendo-label
      class="k-checkbox-label"
      [for]="notification"
      [text]="textAccessor(item)"
      [ngStyle]="{'width':'100%', 'text-align':'right'}"
    ></kendo-label>
  </li>
</ul> -->
